module.exports = __webpack_public_path__ + "img/login.1dc84317.jpg";